import * as React from 'react'
import { Filters } from '../../screens/wip/wip'
import { Staff, WipData } from '../../../../back-end/utilities/apiDefinitions'

interface WipCountProps {
	wipData: WipData | null
	filters: Filters
	allStaff: Staff[]
	selectedJobLabel?: string
}

const WipCount = (props: WipCountProps) => {
	const totalWIPCount = React.useMemo(() => {
		if (props.wipData?.grouping === 'fcje') {
			return props.wipData.familyGroups.flatMap((fg) => fg.clients.flatMap((c) => c.jobs.flatMap((j) => j.timeItems.length))).reduce((a, b) => a + b, 0)
		} else if (props.wipData?.grouping === 'fjcj') {
			return props.wipData.familyGroups
				.flatMap((fg) => fg.jobTypes.flatMap((jt) => jt.clients.flatMap((c) => c.jobs.flatMap((j) => j.timeItems.length))))
				.reduce((a, b) => a + b, 0)
		}
	}, [props.wipData])

	const filterReadable = () => {
		const filters = []
		if (props.filters.clientPartnerId) {
			filters.push({ filter: 'client partner', value: `${props.allStaff.find((s) => s.xpmID === props.filters.clientPartnerId)?.name}` })
		}
		if (props.filters.clientManagerId) {
			filters.push({ filter: 'client manager', value: `${props.allStaff.find((s) => s.xpmID === props.filters.clientManagerId)?.name}` })
		}
		if (props.filters.jobPartnerId) {
			filters.push({ filter: 'job partner', value: `${props.allStaff.find((s) => s.xpmID === props.filters.jobPartnerId)?.name}` })
		}
		if (props.filters.jobManagerId) {
			filters.push({ filter: 'job manager', value: `${props.allStaff.find((s) => s.xpmID === props.filters.jobManagerId)?.name}` })
		}
		if (props.filters.jobStaffId) {
			filters.push({ filter: 'job staff', value: `${props.allStaff.find((s) => s.xpmID === props.filters.jobStaffId)?.name}` })
		}
		if (props.filters.jobNumber) {
			filters.push({ filter: 'job number', value: props.selectedJobLabel || props.filters.jobNumber })
		}
		if (props.filters.jobType) {
			filters.push({ filter: 'job category', value: props.filters.jobType })
		}
		return filters
	}

	const filters = filterReadable()

	return (
		<span>
			{'Showing '}
			<span className="span-bold span-blue">{totalWIPCount}</span>
			{' WIP results'}
			{filters.length > 0 && ' for '}
			{filters.map((f, i) => (
				<span key={i}>
					{filters.length > 1 && i === filters.length - 1 && ' and '}
					{f.filter} <span className="span-bold span-blue">{f.value}</span>
					{i < filters.length - 2 && ', '}
				</span>
			))}
			{' by '}
			<span className="span-bold span-blue">{props.filters.grouping.value === 'fcje' ? 'Client' : 'Job Category'}</span>
			{' until '}
			<span className="span-bold span-blue">{props.filters.endDate.toFormat('d MMMM yyyy')}</span>
		</span>
	)
}

export default WipCount
